const baseUrlDefault = "https://tour.st-beta.dev/";

export const GROUP_CITIES_QUERY_URL = `${
  process.env.NEXT_PUBLIC_TOUR_BASE_URL_API || baseUrlDefault
}group/text-search`;
